import React from "react"
import OrderItem from "../OrderSummary/OrderItem"

export default function({ products, customProducts, currency, orderData }) {
  return (
    <div className="items">
      {products.map(product => (
        <OrderItem
          key={product.id}
          product={product}
          currency={orderData.currency}
          orderUUID={orderData.uuid}
          type="regular"
        />
      ))}
      {customProducts.map(product => (
        <OrderItem
          key={product.id}
          product={product}
          currency={orderData.currency}
          orderUUID={orderData.uuid}
          type="custom"
        />
      ))}
    </div>
  )
}
